export const generatedSourceUseClearanceDossier = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-source-use-clearance-dossier",
  "operatingRule": "Source-use clearance dossiers summarize terms, citation, redistribution, customer-use, and provider-boundary review work. They are not legal clearance and fail closed until source-specific approvals are recorded.",
  "sourceCount": 33,
  "blockedSourceCount": 33,
  "packetCount": 33,
  "blockedPacketCount": 33,
  "classCount": 5,
  "customerUseAllowed": false,
  "rawRedistributionAllowed": false,
  "derivedValuesCustomerUseAllowed": false,
  "decisionStateCounts": {
    "internal-research-only": 5
  },
  "packetPriorityCounts": {
    "P2": 31,
    "P0": 2
  },
  "evidenceHashes": {
    "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4"
  },
  "releaseImpact": "Customer-facing reports can cite source context internally, but commercial/customer use remains blocked until source-specific terms, citation, redistribution, provider-boundary, and named reviewer approvals are attached.",
  "reviewExitCriteria": [
    "Every P0 and P1 source-use packet has terms/license evidence and named reviewer approval.",
    "Raw payload redistribution is explicitly allowed or excluded for every source used in a customer report.",
    "Derived normalized values have source-specific customer-use approval.",
    "Provider marks, logos, endorsement language, standards text, long excerpts, tables, and figures are excluded unless specifically cleared.",
    "Customer report exports include only approved citations, derived values, and allowed-use boundaries."
  ],
  "classDossiers": [
    {
      "sourceUseClass": "commercial-public-source",
      "priority": "P0",
      "sourceCount": 2,
      "riskLevels": [
        "high"
      ],
      "decisionState": "internal-research-only",
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "defaultBoundary": "Commercial source values may be discussed as sourced assumptions only after terms review; no raw page/API content, pricing table reproduction, or endorsement implication.",
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "requiredRightsArtifacts": [
        "captured terms or legal page hash",
        "commercial quote/use boundary",
        "minimal excerpt policy",
        "reviewer approval before customer-facing numeric use"
      ],
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "requiredDecisionIds": [
        "citation-attribution",
        "derived-record-customer-use",
        "excerpt-and-table-boundary",
        "provider-endorsement-boundary",
        "raw-payload-redistribution",
        "terms-license-capture"
      ],
      "blockedPacketCount": 2,
      "rawRedistributionAllowed": false,
      "customerUseAllowed": false,
      "topSources": [
        {
          "sourceId": "spacex-rideshare",
          "title": "SpaceX Rideshare Program",
          "riskLevel": "high",
          "priority": "P0",
          "packetHash": "sha256-9a7afed2d2517e5a7f3d6c0bb9dd58febf2fc8b7d3fe1236721d849b201c8d13",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-clps",
          "title": "Commercial Lunar Payload Services",
          "riskLevel": "high",
          "priority": "P0",
          "packetHash": "sha256-4b3395cfcc70a4f4f0a78c7a0a54b16160a9808c0a58cd586d5085adf8dc28d7",
          "blockerCount": 6
        }
      ],
      "nextAction": "Capture source-specific pricing/terms evidence and named reviewer approval before using commercial-derived values in customer reports.",
      "classDossierHash": "sha256-79efd7e40a02d5159a4551933b4823721a64f63380633cb76d92555ae526adb8"
    },
    {
      "sourceUseClass": "open-source-tool-or-code",
      "priority": "P1",
      "sourceCount": 7,
      "riskLevels": [
        "medium"
      ],
      "decisionState": "internal-research-only",
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "defaultBoundary": "Tool outputs and dependency names may be cited after license capture; bundling, modifying, or redistributing code/artifacts remains blocked until license compatibility is reviewed.",
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "requiredRightsArtifacts": [
        "copyleft or redistribution compatibility review",
        "dependency version and repository URL",
        "license file or SPDX identifier",
        "notice/attribution requirement"
      ],
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "requiredDecisionIds": [
        "citation-attribution",
        "derived-record-customer-use",
        "excerpt-and-table-boundary",
        "provider-endorsement-boundary",
        "raw-payload-redistribution",
        "terms-license-capture"
      ],
      "blockedPacketCount": 7,
      "rawRedistributionAllowed": false,
      "customerUseAllowed": false,
      "topSources": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-1f5b8233a9afddb4ddfef51cae9d77e1ef08dee96d95b45ec77aa90f4501cf81",
          "blockerCount": 6
        },
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-497bf8d836bf57f9e008433cca02f11f6b1b622ac0ed4670a75aa552ab2e9873",
          "blockerCount": 6
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-bbb82d5f622f7f7eb5a78f80d1e8b80fdb03389aad50e04f770de8b208121835",
          "blockerCount": 6
        },
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-0a1ac8eca9fa1943fb5488a535f824daf549e233a37a60243106a9f2e3ccfffe",
          "blockerCount": 6
        },
        {
          "sourceId": "cantera",
          "title": "Cantera",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-f8c02fcec876f0727bd2a3dd2898bfa468e397fbb04f5211bbbbcca27945f453",
          "blockerCount": 6
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-091da51fce102c99c05e3b43636be9a9a0d0b709fbd0950ae741ad065156e656",
          "blockerCount": 6
        },
        {
          "sourceId": "openfoam",
          "title": "OpenFOAM",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-f266f1115629723670abec47ba0b67c47760f49e4f07ba4a28621447372660b9",
          "blockerCount": 6
        }
      ],
      "nextAction": "Capture source-specific terms, citation, redistribution, and reviewer approval before customer-facing use.",
      "classDossierHash": "sha256-8003281e295e7bcc67cba2a9729994f94fd1bb9714fcf277aac96d54ddf13773"
    },
    {
      "sourceUseClass": "standards-body-source",
      "priority": "P1",
      "sourceCount": 4,
      "riskLevels": [
        "medium"
      ],
      "decisionState": "internal-research-only",
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "defaultBoundary": "Standards may be referenced by identifier/version and short citation only; standards text, tables, figures, and procedures remain blocked until reproduction rights are reviewed.",
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "requiredRightsArtifacts": [
        "citation format",
        "license or public-access terms note",
        "review of reproduction limits for tables, figures, and long excerpts",
        "standard identifier and version"
      ],
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "requiredDecisionIds": [
        "citation-attribution",
        "derived-record-customer-use",
        "excerpt-and-table-boundary",
        "provider-endorsement-boundary",
        "raw-payload-redistribution",
        "terms-license-capture"
      ],
      "blockedPacketCount": 4,
      "rawRedistributionAllowed": false,
      "customerUseAllowed": false,
      "topSources": [
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-4281f3c67a8a6ab25a5330221f9fdcb09caee9a65460e185b666addffcb162a6",
          "blockerCount": 6
        },
        {
          "sourceId": "iau-sofa",
          "title": "Standards of Fundamental Astronomy",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-d708b33e51018c98e44e6a3085ff6f4c51e38614caffb6288056764601deb5b8",
          "blockerCount": 6
        },
        {
          "sourceId": "ccsds",
          "title": "Consultative Committee for Space Data Systems",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-983afbacdf83a228cfa1c6fc2db8b2e2d02a058bae244539d7326936b048a586",
          "blockerCount": 6
        },
        {
          "sourceId": "nist-chemistry-webbook",
          "title": "NIST Chemistry WebBook SRD 69",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-bc9c8a83702c167dc0dd82441e737366ee8b2330e009377b2b84f33256bbf71e",
          "blockerCount": 6
        }
      ],
      "nextAction": "Capture source-specific terms, citation, redistribution, and reviewer approval before customer-facing use.",
      "classDossierHash": "sha256-49d0e56137bda97da688e6f6925265ae5e686bc07ed84dd7c302d7a2ce677899"
    },
    {
      "sourceUseClass": "general-public-source",
      "priority": "P2",
      "sourceCount": 5,
      "riskLevels": [
        "medium"
      ],
      "decisionState": "internal-research-only",
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "defaultBoundary": "Citation-only planning context until terms, citation, and reviewer approval are captured.",
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "requiredRightsArtifacts": [
        "access timestamp",
        "citation format",
        "reviewer approval",
        "terms or license note"
      ],
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "requiredDecisionIds": [
        "citation-attribution",
        "derived-record-customer-use",
        "excerpt-and-table-boundary",
        "provider-endorsement-boundary",
        "raw-payload-redistribution",
        "terms-license-capture"
      ],
      "blockedPacketCount": 5,
      "rawRedistributionAllowed": false,
      "customerUseAllowed": false,
      "topSources": [
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-08dfe434aa64c5586595c9c0756846c32a7c12e7ae3da2241191520fc0888a2c",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-mercury",
          "title": "Mercury Facts",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-2b18f1330f735b5a1dba1b6057e6d3a7b7a31a346b0465a16e42f15280c598a7",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-dtn",
          "title": "Delay/Disruption Tolerant Networking",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-c24176e150bbc8dc054a8589b85d3bd909855ac7f98e60e599656d03cb6cddb0",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-cost-estimating-handbook",
          "title": "NASA Cost Estimating Handbook",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-56e69f036d914287fffd6d66631a065e6bae4dc48c8dd420b5c3c9d31774dd55",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-se-handbook",
          "title": "NASA Systems Engineering Handbook",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-18529ac1902153e21a0a88567f0f81981664a8cc38ffe88ec4d78dacf1174d96",
          "blockerCount": 6
        }
      ],
      "nextAction": "Capture source-specific terms, citation, redistribution, and reviewer approval before customer-facing use.",
      "classDossierHash": "sha256-3cb182bbab1c6ef00e766f12ad551ab3fd248d12352459a18324131ce9e81b40"
    },
    {
      "sourceUseClass": "public-data-or-api-source",
      "priority": "P2",
      "sourceCount": 15,
      "riskLevels": [
        "medium"
      ],
      "decisionState": "internal-research-only",
      "customerReportUse": {
        "internalResearch": "allowed-with-citation-context",
        "citationOnly": "allowed-after-citation-draft-review",
        "derivedNormalizedValues": "blocked-until-source-use-review-passes",
        "rawPayloadRedistribution": "blocked",
        "providerMarksOrEndorsement": "blocked",
        "longExcerptsTablesOrFigures": "blocked"
      },
      "defaultBoundary": "Reviewed normalized records may become customer-facing derived values after query, payload hash, unit, uncertainty, and citation review; raw payload redistribution remains blocked.",
      "allowedNow": "Internal planning, source discovery, and short citation context only; this is not legal clearance or customer-use approval.",
      "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
      "requiredRightsArtifacts": [
        "citation and attribution note",
        "normalized record hash",
        "query URL/API parameters",
        "raw payload hash",
        "terms page or archive citation"
      ],
      "requiredReviewDecisions": [
        "terms-license-capture",
        "citation-attribution",
        "raw-payload-redistribution",
        "derived-record-customer-use",
        "provider-endorsement-boundary"
      ],
      "requiredDecisionIds": [
        "citation-attribution",
        "derived-record-customer-use",
        "excerpt-and-table-boundary",
        "provider-endorsement-boundary",
        "raw-payload-redistribution",
        "terms-license-capture"
      ],
      "blockedPacketCount": 15,
      "rawRedistributionAllowed": false,
      "customerUseAllowed": false,
      "topSources": [
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-c7e8a1108b028d154dbf2c958d29a047f2eec0008756d0ab200f0f4bab9f846d",
          "blockerCount": 6
        },
        {
          "sourceId": "horizons-mercury-2024",
          "title": "JPL Horizons Mercury Physical Data",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-89a8b926ccad44332935ad8da2b18b72057f989eab7b5371f457e777deb22f47",
          "blockerCount": 6
        },
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-864ee676bdb8775aef26465d616689e9bb7a128b3d4b264da6f5a129434d3023",
          "blockerCount": 6
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-5509ae5af4c25dc7a954e49ebf73395ea3b8195d3da643c0fdb45929575e9245",
          "blockerCount": 6
        },
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-47fd3f4d01a3bf3328f0b2526ec78e45d9926230622c06be17e95b12b2beb6cf",
          "blockerCount": 6
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-00e966c618c18e5308d81fb4ca949c494a67bd76d003fd0bb212d97e05601f97",
          "blockerCount": 6
        },
        {
          "sourceId": "mpc",
          "title": "Minor Planet Center Data",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-b4cfe2b9062349c13cb2246334bac86f342028f68366ad06441885d3dbdca089",
          "blockerCount": 6
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-290b747abe1952a3fa6bccb68dc75cdfca50f9c3cb2aed84fa46dea4255e8cf1",
          "blockerCount": 6
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-8ccd8569fecc8f4613889fcebbdbe701b35a7d5bee39814795953aabed09ff24",
          "blockerCount": 6
        },
        {
          "sourceId": "usaspending",
          "title": "USAspending.gov",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-44dc86020821ef71a9993b152b34d63c070a75752412776ee7bc52820d1b2f03",
          "blockerCount": 6
        },
        {
          "sourceId": "sec-edgar",
          "title": "SEC EDGAR",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-a1685dc32f2dd10822435e58b6aec9affcb7345f5e6c7f484161306061f35a14",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-spdf",
          "title": "NASA Space Physics Data Facility",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-32c8135a41eab812aca7cd4d453b5cb352916ef453402ec0e20d158272024292",
          "blockerCount": 6
        },
        {
          "sourceId": "nasa-ccmc",
          "title": "Community Coordinated Modeling Center",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-e9a3d92fa64992efdc7fcd16e058bcba03901b7b55667aa734eb373f75eed5fc",
          "blockerCount": 6
        },
        {
          "sourceId": "noaa-swpc",
          "title": "NOAA Space Weather Prediction Center Products and Data",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-8286e8566447f45bb575f58049ee4b072c3969ecf091c32ce69e6015ba6b4b39",
          "blockerCount": 6
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "riskLevel": "medium",
          "priority": "P2",
          "packetHash": "sha256-4596c7e86467c7e6d0114d13df988db5a8376ff3ee9a04436f439191d0725ec5",
          "blockerCount": 6
        }
      ],
      "nextAction": "Capture source-specific terms, citation, redistribution, and reviewer approval before customer-facing use.",
      "classDossierHash": "sha256-115c95adf67664e2f449ac9f6ac36e171fb010e46419a15cf94356b55d1b8713"
    }
  ],
  "markdownPath": "public/source-use-clearance-dossier.md",
  "markdownHash": "sha256-a4b3363a0dceb88d57589cbe5bb0d252eedad46af18c3fa8873fd54be226382e",
  "dossierHash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18"
}
;
